import { render, staticRenderFns } from "./AlbumsPage.vue?vue&type=template&id=24aeafd6&scoped=true&"
import script from "./AlbumsPage.vue?vue&type=script&lang=js&"
export * from "./AlbumsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aeafd6",
  null
  
)

export default component.exports